export default "__VITE_ASSET__hs7Y5pseKRHA$UyudYsjxg__"